module.exports = __webpack_public_path__ + "static/media/course_1-photo.44b2768e.png";